module.exports = __webpack_public_path__ + "static/media/ill_stress_oro_depression.27725802.svg";